module.exports = __webpack_public_path__ + "img/ic_calendar.384fe26a.svg";